import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./link.html";
// looking for [label](href)
const REGEX = /\[([^\[]+)\](\(.+?\))/g;
// looking for ](href)
const REGEX_HREF = /(\]\(.+?\))/g;
// looking for [label]
const REGEX_LABEL = /\[([^\[]+)\]/g;
const SPLIT_PARAM = '%LINK%';

// look for anything in double pound/hash to use as event name
const EVENT_TOKEN_REGEX = /##(.*)##/;
const EVENT_HREF_VALUE = 'javascript:void(0)';

// default parse function for double hashed enclosed event name in href to fire that event name
const DEFAULT_EVENT_NAME_GENERATOR = text => {
  var _hashMatches$1$trim, _hashMatches$;
  const hashMatches = text.match(EVENT_TOKEN_REGEX);
  return (_hashMatches$1$trim = hashMatches === null || hashMatches === void 0 ? void 0 : (_hashMatches$ = hashMatches[1]) === null || _hashMatches$ === void 0 ? void 0 : _hashMatches$.trim()) !== null && _hashMatches$1$trim !== void 0 ? _hashMatches$1$trim : '';
};
const DEFAULT_TEST_IS_INTENAL_LINK = destination => {
  return destination.startsWith('/');
};
let _navigate;
let _testIsInternalLink;
let _useCustomEvents = false;
let _customEventNameGenerator;
export function initializeI18nLinks(navigate, testIsInternalLink = DEFAULT_TEST_IS_INTENAL_LINK, options) {
  var _options$useCustomEve, _options$eventNameGen;
  _navigate = navigate;
  _testIsInternalLink = testIsInternalLink;
  _useCustomEvents = (_options$useCustomEve = options === null || options === void 0 ? void 0 : options.useCustomEvents) !== null && _options$useCustomEve !== void 0 ? _options$useCustomEve : false;
  _customEventNameGenerator = (_options$eventNameGen = options === null || options === void 0 ? void 0 : options.eventNameGenerator) !== null && _options$eventNameGen !== void 0 ? _options$eventNameGen : DEFAULT_EVENT_NAME_GENERATOR;
}

// Without this hack we get the following TypeScript error when building using ESM:  
// 'ariaLabel' is defined as a property in class 'LightningElement', but is overridden here in 'I18nLink' as an accessor.
const HACK_IgnoreOverridePropertyWithAccessorError = LightningElement;
class I18nLink extends HACK_IgnoreOverridePropertyWithAccessorError {
  constructor(...args) {
    super(...args);
    this._message = '';
    this._ariaLabel = '';
    this._target = '_self';
    // This function is used to generate the custom event to be dispatched if _useCustomEvents is enabled and href matches the EVENT_TOKEN_REGEX
    this.customEventGenerator = void 0;
    this._containerElement = null;
    this._hasRendered = false;
  }
  get message() {
    return this._message;
  }
  set message(message) {
    this._message = message;
    if (this._hasRendered) {
      this.createChildren();
    }
  }
  get target() {
    return this._target;
  }
  set target(target) {
    this._target = target;
    if (this._hasRendered) {
      this.createChildren();
    }
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  set ariaLabel(ariaLabel) {
    this._ariaLabel = ariaLabel;
    if (this._hasRendered) {
      this.createChildren();
    }
  }
  createChildren() {
    if (this._containerElement) {
      this._containerElement.remove();
    }
    this._containerElement = document.createElement('div');
    const matches = this.message.match(REGEX);
    if (matches && matches.length > 0) {
      const splitedLabel = this.message.replace(REGEX, SPLIT_PARAM).split(SPLIT_PARAM);
      for (let i = 0; i < splitedLabel.length; i++) {
        this._containerElement.appendChild(document.createElement('span')).innerText = splitedLabel[i];
        if (i < splitedLabel.length - 1) {
          const link = document.createElement('a');
          link.target = this.target;
          link.ariaLabel = this.ariaLabel;
          const labelString = matches[i].match(REGEX_LABEL)[0];
          const cleanLabel = labelString.substring(1, labelString.length - 1);
          link.innerText = cleanLabel;
          const hrefString = matches[i].match(REGEX_HREF)[0];
          let url;
          let eventName;
          if (_useCustomEvents) {
            eventName = _customEventNameGenerator(hrefString);
            url = eventName ? EVENT_HREF_VALUE : hrefString.substring(2, hrefString.length - 1);
          } else {
            url = hrefString.substring(2, hrefString.length - 1);
          }
          link.href = url;
          link.onclick = event => {
            this.dispatchEvent(new CustomEvent('anchor_clicked', {
              detail: {
                eventNameOrUrl: eventName || url,
                label: cleanLabel
              }
            }));
            if (eventName || _navigate && _testIsInternalLink(url)) {
              event.preventDefault();
              if (eventName) {
                var _this$customEventGene, _this$customEventGene2;
                this.dispatchEvent((_this$customEventGene = (_this$customEventGene2 = this.customEventGenerator) === null || _this$customEventGene2 === void 0 ? void 0 : _this$customEventGene2.call(this, eventName)) !== null && _this$customEventGene !== void 0 ? _this$customEventGene : new CustomEvent(eventName));
              } else {
                _navigate(url);
              }
            }
          };
          this._containerElement.appendChild(link);
        }
      }
    } else {
      this._containerElement.appendChild(document.createElement('span')).innerText = this.message;
    }

    // @ts-ignore
    this.template.appendChild(this._containerElement);
  }
  connectedCallback() {
    this.createChildren();
  }
  renderedCallback() {
    if (this._hasRendered) {
      this.createChildren();
    }
    this._hasRendered = true;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(I18nLink, {
  publicProps: {
    message: {
      config: 3
    },
    target: {
      config: 3
    },
    ariaLabel: {
      config: 3
    },
    customEventGenerator: {
      config: 0
    }
  },
  fields: ["_message", "_ariaLabel", "_target", "_containerElement", "_hasRendered"]
});
const __lwc_component_class_internal = _registerComponent(I18nLink, {
  tmpl: _tmpl,
  sel: "i18n-link",
  apiVersion: 62
});
export default __lwc_component_class_internal;